/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuranceEligibilityCheckReport } from './InsuranceEligibilityCheckReport';
import {
    InsuranceEligibilityCheckReportFromJSON,
    InsuranceEligibilityCheckReportFromJSONTyped,
    InsuranceEligibilityCheckReportToJSON,
    InsuranceEligibilityCheckReportToJSONTyped,
} from './InsuranceEligibilityCheckReport';

/**
 * 
 * @export
 * @interface GenerateEligibilityCheckReport200Response
 */
export interface GenerateEligibilityCheckReport200Response {
    /**
     * 
     */
    data?: InsuranceEligibilityCheckReport;
}

/**
 * Check if a given object implements the GenerateEligibilityCheckReport200Response interface.
 */
export function instanceOfGenerateEligibilityCheckReport200Response(value: object): value is GenerateEligibilityCheckReport200Response {
    return true;
}

export function GenerateEligibilityCheckReport200ResponseFromJSON(json: any): GenerateEligibilityCheckReport200Response {
    return GenerateEligibilityCheckReport200ResponseFromJSONTyped(json, false);
}

export function GenerateEligibilityCheckReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateEligibilityCheckReport200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : InsuranceEligibilityCheckReportFromJSON(json['data']),
    };
}

export function GenerateEligibilityCheckReport200ResponseToJSON(json: any): GenerateEligibilityCheckReport200Response {
    return GenerateEligibilityCheckReport200ResponseToJSONTyped(json, false);
}

export function GenerateEligibilityCheckReport200ResponseToJSONTyped(value?: GenerateEligibilityCheckReport200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InsuranceEligibilityCheckReportToJSON(value['data']),
    };
}

